<template>
  <BaseTemplate :isTop="true">
    <div class="purchase-class">
      <Title class="_title" :jpn="t('Xmarket')" />
      <!-- 検索フォーム -->
      <div class="search-container">
        <div class="search-bar">
          <input type="text" v-model="searchParam.freeword" @change="search(1)" />
          <button class="search-button">
            🔍
          </button>
        </div>
      </div>
      <MarketHeader
        @changeSaleType="changeSaleType"
        @handleClear="handleClear"
        @handleSearch="handleSearch"
        :searchParam="searchParam"
        :decodedSelectType="decodedSelectType"
      />
      <!-- <p>{{ cardList }}</p> -->
      <div class="card-list">
        <MarketCardList
          v-if="cardList"
          :cardList="cardList.list"
          :cardListTitle="t('検索結果')"
          :currentUser="userDetail"
          @handleBidClick="bidCard"
          @handleCartClick="appendCard"
          @handlePriceChange="handlePriceChange"
          @refreshList="refresh"
        />
        <BoxPager
          v-if="cardList.page && cardList.page.pages && cardList.page.pages.length > 1"
          class="box-pager"
          :totalPageCount="cardList.page.all_page"
          :currentPageCount="cardList.page.page"
          :dispBoxCount="cardList.page.pages.length"
          :pages="cardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
      <Cart
        @handleOverlayClick="closeCart"
        @deleteItem="deleteItem"
        :userDetail="userDetail"
        :cartList="cartList"
        :isVisible="isVisible"
      />
      <!-- 以下、入札ポップアップ -->
      <CommonOverlay @handleOverlayClick="closeBid" class="overlay_conf" v-if="showCardDetail">
        <div @click.stop>
          <CommonModal @click.stop class="modal market-modal">
            <div class="card-info">
              <div class="card-info-text">
                <MarketCardList
                  :cardList="[popupCardData]"
                  :oneSheet="true"
                  :currentUser="userDetail"
                  :hideButtons="true"
                />
              </div>
              <div class="text-box">
                <TextBox
                  class="text-box"
                  v-model="price"
                  type="number"
                  :placeholder="t('販売価格を入力してください')"
                />
                <span>
                  {{ t("円") }}
                </span>
              </div>
              <ErrorMessage
                v-if="errorMessageCard || errorMessageMarket || errorMessageParam"
                class="error-message"
                :message="errorMessageCard || errorMessageMarket || errorMessageParam"
              />
            </div>
            <div class="button-area">
              <BuyButton
                :isArrow="false"
                :text="t('入札する')"
                @handleSquareBtnClick="submit(popupCardData, 0)"
              />
              <button class="auction-button" @click="closeBid">
                {{ t("キャンセル") }}
              </button>
            </div>
          </CommonModal>
        </div>
      </CommonOverlay>
      <!-- 以下、価格変更ポップアップ -->
      <CommonOverlay
        v-if="showPriceChangeModal"
        class="overlay_conf"
        @handleOverlayClick="closePriceChangeModal"
      >
        <div @click.stop>
          <CommonModal @click.stop class="modal market-modal">
            <div class="card-info">
              <div class="card-info-text">
                <MarketCardList
                  :cardList="[priceChangeCardData]"
                  :isHistory="false"
                  :isMyList="true"
                  :currentUser="userDetail"
                  :oneSheet="true"
                  :hideButtons="true"
                />
              </div>
              <div class="text-box">
                <TextBox
                  class="text-box"
                  type="number"
                  v-model="newPrice"
                  :placeholder="t('販売価格を入力してください')"
                />
                <span :class="{ abroad: userAbroad }">
                  {{ t('円') }}
                </span>
              </div>
              <ErrorMessage
                v-if="errorMessageCard || errorMessageMarket || errorMessageParam"
                class="error-message"
                :message="errorMessageCard || errorMessageMarket || errorMessageParam"
              />
            </div>
            <div class="button-area">
              <div class="price-info">
                {{ formatPriceMessage(priceChangeCardData.min_price) }}
              </div>
              <BuyButton
                :isArrow="false"
                :text="t('販売価格を更新する')"
                @handleSquareBtnClick="submitPriceChange"
              />
            </div>
          </CommonModal>
        </div>
      </CommonOverlay>
    </div>
  </BaseTemplate>
</template>

<script>
import { separateCharacterNumber } from '@/common/util/format';
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import MarketCardList from '@/components/organisms/MarketCardList.vue';
import Title from '@/components/molecules/Title02.vue';
import MarketHeader from '@/components/molecules/Header/MarketHeader.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import Cart from '@/components/pages/Market/Cart.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'Market',
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    MarketCardList,
    BoxPager,
    MarketHeader,
    Cart,
    CommonOverlay,
    CommonModal,
    BuyButton,
    TextBox,
    ErrorMessage,
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },
  data() {
    return {
      type: null,
      price_min: null,
      price_max: null,
      orderBy: '',
      page: 1,
      showCardDetail: false,
      postData: {},
      searchParam: {
        freeword: '',
        sale_type: null,
        showDetailSearch: false,
        price_min: null,
        price_max: null,
        order_by: 'price_desc',
        card_type: [],
        tokka_filter: '',
        is_sale: false,
      },
      popupCardData: {},
      errorMessage: null,
      errorMessageCard: null,
      errorMessageMarket: null,
      errorMessageParam: null,
      price: null,
      showPriceChangeModal: false,
      priceChangeCardData: {},
      newPrice: '',
    };
  },
  computed: {
    ...mapGetters({
      marketList: 'market/resultMarketList',
      selectType: 'cardType/cardTypeList',
      userDetail: 'user/currentUserDetail',
      currentUser: 'user/currentUser',
      marketCartList: 'market/resultMarketCartList',
      isCartOpen: 'market/isCartOpen',
      resultMarketPriceChange: 'market/resultMarketPriceChange',
    }),
    cardList() {
      if (this.marketList) {
        return this.marketList;
      }
      return [];
    },
    cartList() {
      if (this.marketCartList) {
        return this.marketCartList;
      }
      return [];
    },
    isVisible() {
      return this.isCartOpen;
    },
    decodedSelectType() {
      const allowedIds = [1, 2, 7, 3, 5, 9]; // 表示したいタイトルのIDを配列で指定
      if (this.selectType) {
        return this.selectType
          .filter((item) => allowedIds.includes(item.id))
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
      }
      return [];
    },
    userAbroad() {
      if (this.currentUser) {
        return this.currentUser.language_id !== 1;
      }
      return false;
    },
  },
  watch: {
    resultPurchaseSave(newResult) {
      if (newResult.state !== 200 || (newResult.error && newResult.error.length !== 0)) {
        this.errorMessage = newResult.error;
        return;
      }
      this.errorMessage = {};
    },
    resultMarketPriceChange(newResult) {
      if (!newResult) {
        return;
      }
      if ((newResult.state !== 200) || (newResult.errors && Object.keys(newResult.errors).length > 0)) {
        this.errorMessageParam = newResult.errors?.param?.[0] || null;
        this.errorMessageCard = newResult.errors?.card?.[0] || null;
        this.errorMessageMarket = newResult.errors?.market?.[0] || null;
        return;
      }

      this.showPriceChangeModal = false;
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.newPrice = '';
      this.refresh();
    },
  },

  created() {
    this.$store.dispatch('market/list', { postParam: this.searchParam });
    this.$store.dispatch('cardType/setCardTypeList');
    this.$store.dispatch('market/historyList');
    this.$store.commit('market/setIsCartOpen', false);
  },

  methods: {
    changeCurrentPageCount(page) {
      this.page = page;
      this.search(page);
    },
    changeSaleType(mode) {
      this.searchParam.sale_type = mode;
      this.search();
    },
    handleSearch(searchParam) {
      this.searchParam = searchParam;
      this.search();
    },
    handleClear() {
      this.searchParam = {
        freeword: '',
        sale_type: null,
        price_min: null,
        price_max: null,
        order_by: 'price_asc',
        showDetailSearch: false,
        card_type: [],
        tokka_filter: '',
        is_sale: false,
      };
      this.search();
    },
    search(page = 1) {
      if (this.searchParam.sale_type === 999999) {
        this.searchParam.sale_type = null;
      }
      this.$store.dispatch('market/list', {
        pageNumber: page,
        postParam: this.searchParam,
      });
    },
    refresh() {
      // 表の再取得
      this.search(1);
      // ユーザー詳細の更新
      this.$store.dispatch('user/setCurrentUser');
    },
    async appendCard(postData) {
      if (!postData) {
        return;
      }
      try {
        // カート追加APIの完了を待つ
        await this.$store.dispatch('market/add_cart', {
          postParams: {
            market_id: postData.id,
            successMessage: this.t('カートに追加しました'),
          },
        });
        // 追加が成功した場合のみカートリストを更新
        const addResult = this.$store.getters['market/resultMarketAddCart'];
        if (addResult && addResult.state === 200) {
          // カートリストを更新
          await this.$store.dispatch('market/historyList');
        }
      } catch (error) {
        console.error('カート追加でエラーが発生しました:', error);
      }
    },
    closeCart() {
      this.$store.dispatch('market/toggleCart');
    },
    bidCard(cardData) {
      this.popupCardData = cardData;
      this.showCardDetail = true;
    },
    closeBid() {
      this.showCardDetail = false;
    },
    async deleteItem(item) {
      console.log('deleteItem', item);
      await this.$store.dispatch('market/delete_cart', {
        postParams: { id: item.id },
      });
      await this.$store.dispatch('market/historyList');
    },
    handlePriceChange(cardItem) {
      this.priceChangeCardData = cardItem || {};
      this.newPrice = cardItem?.price ? String(cardItem.price) : '';
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.showPriceChangeModal = true;
    },
    closePriceChangeModal() {
      this.showPriceChangeModal = false;
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
    },
    submitPriceChange() {
      if (!this.priceChangeCardData || !this.priceChangeCardData.id) {
        return;
      }
      const postParams = {
        market_id: this.priceChangeCardData.id,
        price: this.newPrice,
      };
      this.$store.dispatch('market/price_change', { postParam: postParams });
    },
    formatPriceMessage(min) {
      if (!min) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '{min}円以上の価格で出品できます。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{min}', this.$options.filters.comma(min));
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-class {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  color: #042859;
  ._title {
    margin-top: 20px;
    max-width: 900px;
    margin: 0 auto;
  }
  //検索バーとフィルター___________________
  .search-container {
    max-width: 900px;
    // background-color: #f0f0f0;
    margin: 0 auto;
    width: 90%;
    padding: 20px 20px 0 20px;
    text-align: center;
    .search-bar {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px;
      position: relative;
      margin-bottom: 20px;
      border: 1px solid $gray2;
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .search-button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
  // モーダルウィンドウ______________________
  .overlay_conf{
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .market-modal {
      border: none;
      box-shadow:  0 0px 20px rgba(0, 0, 0, 1.0);
      border-radius: 10px;
      width: 600px;
      max-height: 90%;
      overflow-y: auto;
      padding: 20px;
      position: relative;
      @media screen and (max-width: $tabletWidth) {
        width: 400px;
      }
      @media screen and (max-width: $mobileWidth) {
        width: 320px;
        margin: 0 auto;
      }
      .card-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
        .card-info-text {
          margin-top: 10px;
        }
        .text-box {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 230px;
          margin: 0 auto; // 親幅に対して中央に配置
          font-size: 18px;
          position: relative;
          span {
            position: absolute;
            right: -25px; // inputの右端内側に表示
            pointer-events: none;
            font-weight: bold;
            &.abroad {
              right: -38px;
            }
          }
        }
      }
      .button-area {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 20px;
        button{
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          border-radius: 0;
          border: none;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .auction-button {
          padding: 10px 25px;
          background: #a1a2a2;
          color: white;
          font-weight: bold;
          border: none;
          cursor: pointer;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          @media screen and (max-width: $tabletWidth) {
            padding: 5px 15px;
          }
        }
        .price-info {
          font-size: 14px;
          color: #666;
          text-align: center;
          .tax-info {
            color: $red;
          }
        }
      }
    }
  }
}
</style>
